export default {"src":"https://fishbrain.com/_next/static/media/pickerel.09cc5716.svg","height":115,"width":230,"blurWidth":0,"blurHeight":0};